export * from './get-window.factory';